var ProductReviews, base;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.Model = require('../models/product_review');

ProductReviews.PastPurchases.Collection = Backbone.Collection.extend({
  defaultTimeout: 5000,
  model: ProductReviews.Model,
  initialize: function(models, options1) {
    this.options = options1;
    _.extend(this, this.options);
    _.bindAll(this, 'fetchSuccess', 'fetchError');
    return this.fetch({
      success: this.fetchSuccess,
      error: this.fetchError
    });
  },
  _prepareModel: function(model, options) {
    _.extend(options, this.options);
    options = _.omit(options, ['dealUuid', 'parse', 'view']);
    return Backbone.Collection.prototype._prepareModel.call(this, model, options);
  },
  url: function() {
    return this.rootUrl + "/past_purchases";
  },
  sync: function(method, collection, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.PastPurchases.timeout || this.defaultTimeout;
    return Backbone.Collection.prototype.sync.call(this, method, collection, options);
  },
  excludeCurrentDeal: function() {
    return this.remove(this.where({
      dealUuid: this.dealUuid
    }));
  },
  fetchSuccess: function() {
    this.excludeCurrentDeal();
    if (!this.length) {
      return this.view.hidePastPurchasesLoader();
    }
    return this.view.showPastPurchases();
  },
  fetchError: function() {
    return this.view.hidePastPurchasesLoader();
  }
});

module.exports = ProductReviews.PastPurchases.Collection;

//# sourceMappingURL=data:application/json;base64,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
